import { render, staticRenderFns } from "./DashboardHeader.vue?vue&type=template&id=1d74840b&"
import script from "./DashboardHeader.vue?vue&type=script&lang=js&"
export * from "./DashboardHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Pipelines\\release\\06.04\\maintenance\\Fontes\\corp\\produto\\wes\\WebApp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d74840b')) {
      api.createRecord('1d74840b', component.options)
    } else {
      api.reload('1d74840b', component.options)
    }
    module.hot.accept("./DashboardHeader.vue?vue&type=template&id=1d74840b&", function () {
      api.rerender('1d74840b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "content/components/ui/DashboardHeader.vue"
export default component.exports